import { Button, ButtonToolbar } from 'reactstrap';
import { useContext, useState } from 'react';
import { useParams } from 'react-router';
import { SHORTCUTS } from '../../constants/shortcuts';
import { mapModes } from '../../constants/map';
import ButtonWithShortcut from '../basics/ButtonWithShortcut';
import { MapContext } from '../../contexts/MapContext';
import DeletingToolbar from './DeletingToolbar';
import { asQuantityWithUnit } from '../../utils/formatters';

const MultiLayerFeatureToolbar = () => {
  const { farmId } = useParams();
  const {
    // @ts-expect-error MapContext not migrated to TS
    mapState: { selectedLayerFeatureIds, setMapMode },
    // @ts-expect-error MapContext not migrated to TS
    layers: { deleteLayerFeatures },
  } = useContext(MapContext);

  const [deleting, setDeleting] = useState(false);

  const numFeatures = asQuantityWithUnit(
    'features',
    'feature',
  )(selectedLayerFeatureIds.size);

  if (deleting) {
    return (
      <DeletingToolbar
        name={numFeatures}
        onCancel={() => {
          setDeleting(false);
        }}
        onConfirm={() => {
          deleteLayerFeatures([...selectedLayerFeatureIds], farmId);
          setMapMode(mapModes.LAYER_ENGAGED);
        }}
      />
    );
  }
  return (
    <ButtonToolbar className="d-flex align-items-center">
      <Button
        className="mr-2"
        onClick={() => setDeleting(true)}
        outline
        size="sm"
      >
        Delete Selected
      </Button>
      <ButtonWithShortcut
        color="primary"
        onClick={() => setMapMode(mapModes.LAYER_ENGAGED)}
        shortcut={SHORTCUTS.CLOSE.key}
        size="sm"
      >
        Done
      </ButtonWithShortcut>
    </ButtonToolbar>
  );
};

export default MultiLayerFeatureToolbar;
